// extracted by mini-css-extract-plugin
export default {"login_container":"LoginScreen_login_container__+VHG7","form-container":"LoginScreen_form-container__9ImfM"};